<template>
    <div id="theCredentials" class="theCredentials">
        <el-dialog
            :title="diagTitle"
            :visible.sync="showFlag"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <div class="credential-content">
                <span class="title">Client ID<span style="color: red;">*</span>：</span>
                <el-input readonly v-model="appClientID"></el-input>
                <span class="title">Client Secret<span style="color: red;">*</span>：</span>
                <el-input readonly v-model="appClientSecret"></el-input>
                <span style="color: red;" class="title"
                    >注意：请妥善保存Client ID及Client Secret，<span style="font-weight: bold;">本信息只显示一次</span
                    >,如有遗失，请联系官网管理员</span
                >
                <span class="title">
                    <ul>
                        <li class="weli">Email：cloud@pkpm.com.cn</li>
                        <li class="weli">电话：<span style="margin-left: 7px;">189-1614-5929（微信同号） 吴经理</span></li>
                    </ul>
                </span>
                <div class="btn-Group">
                    <el-button size="small" type="success" class="btnSave" @click="submitSave">保存至本地</el-button>
                    <el-button size="small" type="success" class="btnSure" @click="submitSure">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'theCredentials',
    components: {},
    data() {
        return {
            showFlag: true, // 关闭模态框
            diagTitle: '',
            downLoadStatus: false, // 是否已经下载了
            appClientID: '',
            appClientSecret: '',
        };
    },
    mounted() {
        this.diagTitle = '应用权限信息';
        this.appClientID = this.$store.state.user.userId.CLIENT_ID;
        this.appClientSecret = this.$store.state.user.userId.CLIENT_SECRET;
    },
    methods: {
        handleClose() {
            const _self = this;
            if (this.downLoadStatus) {
                _self.$parent.initPage();
                _self.appClientID = '';
                _self.appClientSecret = '';
                //  关闭模态框
                _self.$store.commit('SET_USERSTATUS', false);
                // _self.showFlag = false
            } else {
                this.$confirm('您还未保存Client相关信息，确认关闭？')
                    .then((res) => {
                        _self.$parent.initPage();
                        _self.appClientID = '';
                        _self.appClientSecret = '';
                        //  关闭模态框
                        _self.$store.commit('SET_USERSTATUS', false);
                        // _self.showFlag = false
                    })
                    .catch((err) => {});
            }
        },
        submitSave() {
            this.downLoadStatus = true;
            const element = document.createElement('a');
            // 文件的名称
            element.download = 'appCredentials.txt';
            element.style.display = 'none';
            const appCredentials = `appClientID:${this.appClientID}\nappClientSecret: ${this.appClientSecret}`;
            let tips = '\n注意： 请妥善保管Id&secrect,一但遗失,请联系管理员重新获取。';
            tips += '\nEmail：cloud@pkpm.com.cn';
            tips += '\n 189-1614-5929（微信同号） 吴经理';
            const blob = new Blob([appCredentials + tips]);
            element.href = URL.createObjectURL(blob);
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        submitSure() {
            const _self = this;
            this.$confirm('您确定已经保存Client相关信息，并关闭？')
                .then((res) => {
                    _self.$parent.initPage();
                    _self.appClientID = '';
                    _self.appClientSecret = '';
                    //  关闭模态框
                    _self.$store.commit('SET_USERSTATUS', false);
                })
                .catch((err) => {});
        },
    },
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
.theCredentials >>> .el-upload__input
  display none
.theCredentials >>> .el-dialog
  width 450px
.theCredentials >>> .el-dialog__header
  width 450px
  height 40px
  line-height 40px
  font-family 'MicrosoftYaHei'
  padding 0
  padding-left 30px
  display flex
  align-items center
  .el-dialog__title
    color $font-black
    font-size 15px
  .el-dialog__headerbtn
    top 0px
    .el-dialog__close
      color $font-black
.theCredentials
  .credential-content
    .title
      line-height 36px
      user-select text
  .btn-Group
    display flex
    margin-top 10px
    justify-content flex-end
    .btnSave
      width 100px
      height 40px
      border-radius 20px
      border 0px
      background-color rgb(255, 73, 41)
    .btnSure
      width 100px
      height 40px
      border-radius 20px
      border 0px
      background-color #0C78E2
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/theCredentials.vue